module.exports = __webpack_public_path__ + "static/media/imageResizer.731d136c.png";